import React from "react";
import Page, { PageProps } from "../Page";
import Text from "antd/lib/typography/Text";
import Header from "../../components/Header";
import { IPasswordResetPresenter } from "../../../presenter/authentication/PasswordResetPresenter";
import PasswordResetForm from "../../components/authentication/PasswordResetForm";
import Title from "antd/es/typography/Title";

export interface Props extends PageProps {}
export interface State extends IPasswordResetPresenter {}

export default class PasswordResetPage extends React.Component<Props, State> {
  private subscriptionId: number = 0;

  constructor(props: any) {
    super(props);
    this.state = { ...props };
  }

  componentDidMount() {
    this.subscriptionId = this.state.store.subscribe((result) => {
      return this.setState((prevState) => result);
    });
  }

  componentWillUnmount() {
    this.state.store.unsubscribe(this.subscriptionId);
  }

  render() {
    const {
      translate,
      languageCode,
      changeLanguage,
      credentials,
      setCredentialsValue,
      submit,
      disableSubmit,
      validationErrors,
      loaders
    } = this.state;

    return (
      <Page {...this.props}>
        <Header
          languagePickerVisible={true}
          onLanguageChange={(languageCode) => changeLanguage(languageCode)}
          language={languageCode}
        />
        <div className="reset-password-form-wrapper">
          <div className="reset-password-form-container">
            <div
              style={{
                display: "flex",
                alignItems: "center",
                justifyContent: "center",
                flexDirection: "column"
              }}>
              <Title
                level={4}
                style={{ margin: 0, padding: 0, marginBottom: 5 }}>
                {translate("pages.password_reset")}
              </Title>
              <Text style={{ marginBottom: 10 }}>
                {translate("password_reset.note")}
              </Text>
            </div>
            <PasswordResetForm
              credentials={credentials}
              translate={translate}
              setCredentialsValue={setCredentialsValue}
              resetPassword={submit}
              resetPasswordDisabled={disableSubmit}
              loading={loaders.passwordReset}
              validationErrors={validationErrors}
            />
          </div>
        </div>
      </Page>
    );
  }
}
